
/**
 * 알림 유형별 설정
 */
export type NotificationSettingsUpdateRequestTypeSettings = {
  /** 팔로우 알림 활성화 여부 */
  follow?: boolean;
  /** 좋아요 알림 활성화 여부 */
  like?: boolean;
  /** 멘션 알림 활성화 여부 */
  mention?: boolean;
  /** 답글 알림 활성화 여부 */
  reply?: boolean;
  /** 리트윗 알림 활성화 여부 */
  retweet?: boolean;
  /** 시스템 알림 활성화 여부 */
  system?: boolean;
};
